/**
 * ═══════════════════════════════════════════════════════════════════════
 * ГРАНЬ СЛИВА — ПОЛТОРА ПРЕДЕЛА, И ЧИСЛО ЭТО ВО ВСЁМ КАБИНЕТЕ ОДНО.
 *
 * Служба считает вердикты по тому же множителю (`ГРАНЬ` в
 * `src/rk/celi.ts`). Двоился он и раньше — литералом `* 1.5` в окне
 * целей, — а с 27.08 его называет ещё и плашка «поставьте предел».
 * Три места с одним числом расходятся на первой же правке, и человек
 * увидит «выше 27 %» в плашке, «выше 30 %» в окне и красную строку
 * при 28 % в таблице.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫЙ ФАЙЛ, А НЕ СТРОКА В `pages/celi.tsx`, ГДЕ ОН ЖИЛ.
 * С 28.08 по этому числу красится столбец ДРР в таблице кампаний
 * (`campaign/columns.ts`). Забери он число из страницы целей — и вместе
 * с одной цифрой в кусок таблицы уехали бы окно целей, react-query
 * и всё, что тянет за собой страница. Голое число ничего за собой
 * не тянет: этим и ценно.
 *
 * Сторож — `web/src/pages/celi-gran.spec.ts`: число здесь и в службе
 * обязано совпадать.
 * ═══════════════════════════════════════════════════════════════════════
 */
export const ГРАНЬ = 1.5;
